export default __webpack_public_path__ + "static/Screenshot3-884ec718e466ab9898e6817593b3cb77.jpg";